export const FETCH_FEEDBACK_INSIGHTS_OVERVIEW = 'app/FeedbackInsights/FETCH_OVERVIEW';
export const FEEDBACK_INSIGHTS_OVERVIEW_LOADED = 'app/FeedbackInsights/OVERVIEW_LOADED';
export const FEEDBACK_INSIGHTS_OVERVIEW_FAILED = 'app/FeedbackInsights/OVERVIEW_FAILED';

export const FETCH_FEEDBACK_INSIGHTS_RATING_TREND = 'app/FeedbackInsights/FETCH_RATING_TREND';
export const FEEDBACK_INSIGHTS_RATING_TREND_LOADED = 'app/FeedbackInsights/RATING_TREND_LOADED';
export const FEEDBACK_INSIGHTS_RATING_TREND_FAILED = 'app/FeedbackInsights/RATING_TREND_FAILED';

export const FETCH_FEEDBACK_INSIGHTS_SERVICE_PERIOD = 'app/FeedbackInsights/FETCH_SERVICE_PERIOD';
export const FEEDBACK_INSIGHTS_SERVICE_PERIOD_LOADED = 'app/FeedbackInsights/SERVICE_PERIOD_LOADED';
export const FEEDBACK_INSIGHTS_SERVICE_PERIOD_FAILED = 'app/FeedbackInsights/SERVICE_PERIOD_FAILED';

export const FETCH_FEEDBACK_INSIGHTS_OUTLET_COMPARISON = 'app/FeedbackInsights/FETCH_OUTLET_COMPARISON';
export const FEEDBACK_INSIGHTS_OUTLET_COMPARISON_LOADED = 'app/FeedbackInsights/OUTLET_COMPARISON_LOADED';
export const FEEDBACK_INSIGHTS_OUTLET_COMPARISON_FAILED = 'app/FeedbackInsights/OUTLET_COMPARISON_FAILED';
